<div class="modals info-message" [class.modals-show]="isModalMessage" [class.modals-hide]="!isModalMessage">
  <div *ngIf="infoMessage && infoMessage.id" [innerHTML]="infoMessage.text" class="contacts"></div>
  <a *ngIf="infoMessage && infoMessage.id" (click)="infoMessageRead(infoMessage.id)" class="button" [class.disabled]="isSending">Ознайомлений</a>
</div>

<div class="dark-layer not-hide" [class.modals-show]="isDarkBackgroundNotHide"></div>
